//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
    /**
     * Angular has a build in orderBy filter. This filter only works on lists, though ng-repeat works for objects as well.
     * This add object support for the orderBy filter.
     *
     */
  angular.module('curalate').filter('orderObjectBy',
        () => function(object, attr, reverse) {
          const sorted = _(object).sortBy(attrObj => _(attrObj).isObject() && _(attrObj).has(attr) && attrObj[attr]);
          return reverse ? sorted.reverse() : sorted;
        },
    );
})();
